import styled from 'styled-components';
import { ListItem } from '@material-ui/core';

export const RawListItem = styled(ListItem)`
  padding: 0;
`;
